import { emptyApi as api } from "./emptyOldApi";

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRedemptions: build.query<Redemption[], void>({
      query: () => "/sb-redemption/admin/redeem"
    }),
    getRedemptionsAllVendors: build.query<Redemption[], void>({
      query: () => "/sb-redemption/admin/redeem?vendor_id=ALLVENDOR"
    }),
    getAvailability: build.query<Availability[], void>({
      query: () => "/sb-data-mapping/inventory/availability",
      // providesTags: ["Availability"] // Uncomment when ready for caching/tagging
    }),
    getInventory: build.query<SimCard[], void>({
      query: () => "/sb-data-mapping/inventory"
    }),
    updateTelechoiceInventory: build.mutation<void, UpdateTelechoiceInventory>({
      query: (body) => ({
        url: "/sb-redemption/admin/telechoice-inventory",
        method: "POST",
        body: body
      })
    }),
  }),
});

/**
 * Types
 * This corresponds to the array of objects like:
 * [
 *   {
 *     "title": "Vodafone eSIM",
 *     "count": 56
 *   }
 * ]
 */
export type Availability = {
  title: string;
  count: number;
};

export type Redemption = {
  orderId: string;
  status: string;
  createdAt: string;
  passportNumber: string;
  vendorId: string;
  email: string;
  assignedSimSn: string;
  surname: string;
  middleName?: string;
  kycSubmittedBy: string;
  updatedAt: string;
  dob: string;
  passportCountry: string;
  simIdx: number;
  arrivalDate: string;
  givenName: string;
  productId: string;
  manualQr?: boolean;
}

export interface SimCard {
  simIdx?: string;
  orderProcessedDate: string; // Format: "YYYY-MM-DD HH:MM:SS"
  orderProcessedDateISO: string | undefined; // Format: "YYYY-MM-DD HH:MM:SS"
  dateTime: string; // Format with milliseconds: "YYYY-MM-DD HH:MM:SS.mmmmmm"
  status: string;
  comments: string;
  name: string;
  simNo: string;
  confirmationCode: string;
  ldapImageUrl: string;
  activationCodeUri: string;
  orderNumber: string;
  expiryDate: string; // Format: "YYYY-MM-DD"
  activationCode: string;
  smDpAddress: string;
  iccid: string;
  productCode: string;
  customerEmail: string;

  empName?: string;
}

export interface UpdateTelechoiceInventory {
  orderId: string;
  simIdx: string;
  confirmationCode: string;
  custEmail: string;
  empName: string;
}


export { injectedApi as slowboatApi };

export const {
  useGetAvailabilityQuery,
  useGetRedemptionsQuery,
  useGetRedemptionsAllVendorsQuery,
  useGetInventoryQuery,
  useUpdateTelechoiceInventoryMutation
} = injectedApi;